import React from "react";
import { Avatar } from "antd";

// Pure leaf — one ACWR dot. Prop trimmed to just `color` (v1's unused props dropped).
export const ACWRDot = ({ color }) => (
    <Avatar
        className="stv2-tracker-ACWR-dots"
        src={undefined}
        style={{ backgroundColor: color }}
        size={8}
        shape="circle"
    />
);
